import moment from 'moment';

export const getQueueGuessingRows = (data) => {
	const rows = data.map((d, i) => {
		const createdAtWeekend = [5, 6, 7].includes(
			moment(d.created_at).utc().isoWeekday(),
		);

		const weekendBonus = createdAtWeekend ? 5 : 0;

		const [firstResult, secondResult] = d.results.sort(
			(a, b) => a.days_since_current_monday - b.days_since_current_monday,
		);
		const currentMondayDate = moment(d.created_at).isoWeekday(1);
		const result1Date = currentMondayDate
			.clone()
			.add(firstResult.days_since_current_monday + weekendBonus, 'days');
		const result2Date = secondResult?.days_since_current_monday
			? currentMondayDate
					.clone()
					.add(secondResult.days_since_current_monday + weekendBonus, 'days')
			: null;

		return (
			<tr key={i}>
				<td>{i + 1}.</td>
				<td>{moment(d.created_at).format('YYYY-MM-DD HH:mm')}</td>
				<td>{d.queue.name}</td>
				<td>{d.t2_fresh || '----'}</td>
				<td>{firstResult?.min_element_in_target}</td>
				<td>{firstResult?.target_dequeue_count}</td>
				<td>{firstResult?.result}</td>
				<td>{result1Date.format('YYYY-MM-DD')}</td>
				<td>{secondResult?.result}</td>
				<td>{result2Date && result2Date.format('YYYY-MM-DD')}</td>
			</tr>
		);
	});

	return rows;
};
